// extracted by mini-css-extract-plugin
module.exports = {"container":"SsProfile_container__1hP65","branch":"SsProfile_branch__2Dm_R"};